import {LoadingSkeleton} from '@github-ui/skeleton/LoadingSkeleton'

export function EntireDiffLoadingSkeleton({lines}: {lines?: number}) {
  return (
    <div className="border borderColor-muted rounded">
      <div
        className="border-bottom bgColor-muted rounded-top-2"
        style={{padding: 'var(--base-size-6) var(--base-size-8)', borderColor: 'var(--borderColor-muted)'}}
      >
        <div className="d-flex flex-items-center" style={{height: 'var(--control-small-size)'}}>
          <LoadingSkeleton height={'sm'} variant="rounded" width="random" />
        </div>
      </div>
      <div className="d-flex flex-column gap-2 p-3">
        {Array.from({length: lines || 5}).map((_, index) => (
          // eslint-disable-next-line @eslint-react/no-array-index-key
          <LoadingSkeleton key={`loading-skeleton-${index}`} height={'sm'} variant="rounded" width="random" />
        ))}
      </div>
    </div>
  )
}

try{ EntireDiffLoadingSkeleton.displayName ||= 'EntireDiffLoadingSkeleton' } catch {}